"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var register_1 = require("./register");
exports.RegisterService = register_1.RegisterService;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/register/services/index.js
// module id = 326
// module chunks = 0